import React, { useEffect, useState } from "react";
import { MatterService } from "../../../services/ClientService";
import { useParams, Link } from "react-router-dom";
import * as APIModels from "../../../models";
import {
    Alert,
    Card,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Input,
} from "@mui/material";
import { Edit, Star } from "@mui/icons-material";
import {
    WriteableMergeField,
    WriteableMergeFields,
} from "../MatterManagmentTypes";
import DatabaseCard from "../DatabaseCard";

type severity = ["success" | "info" | "warning" | "error" | undefined];

const EditPage = () => {
    const { matterId } = useParams<{ matterId?: string }>();
    const [matter, setMatter] = useState<APIModels.MatterResponseV2>();
    const [expanded, setExpanded] = useState<boolean>(true);
    const [matterIdentifier, setMatterIdentifier] = useState<number>(0);
    const [mfRowShow, setMfRowShow] = useState(false);
    const [mergeField, setMergeField] = useState<WriteableMergeField>();
    const [deleteModal, setDeleteModal] = useState<boolean>();
    const [deleteing, setDeleting] = useState<string>();
    const [statuses, setStatuses] = useState<
        Array<APIModels.MatterLogResponse>
    >([]);
    const [noEditMergeField, setNoEditMergeField] =
        useState<WriteableMergeField>();
    const [mergeFields, setMergefields] = useState<WriteableMergeFields>([
        {
            key: 0,
            identifier: "Populating",
            value: "Please wait",
        } as WriteableMergeField,
    ] as WriteableMergeFields);
    if (matterId === undefined) {
        window.location.href = "/matter/management";
    }

    const refreshData = async () => {
        const response = await MatterService.getV2({
            matterId: matterId ?? APIModels.EmptyGuid,
        });
        if (response.data && response.successful) {
            setMatter(response.data);
            if (response.data.mergeFields !== undefined) {
                const mergfields = response.data.mergeFields;
                const mfs = Object.keys(
                    response.data.mergeFields
                ).map<WriteableMergeField>((mf, i) => {
                    return {
                        key: i,
                        identifier: mf,
                        value: (mergfields as { [key: string]: string })[
                            mf
                        ] as string,
                    } as WriteableMergeField;
                }) as WriteableMergeFields;
                setMergefields(mfs);
                const identifier = response.data.identifier;
                if (identifier) {
                    const k = mfs.findIndex(
                        (mfs) =>
                            identifier.matterMapping?.fieldKey ===
                            mfs.identifier
                    );
                    setMatterIdentifier(k);
                }
            } else console.error();
        } else {
            alert(response.errorMessage);
        }
    };

    const changeIdentifier = async (
        mfChangeIdentifier: WriteableMergeField
    ) => {
        const response = await MatterService.changeIdentifier({
            body: {
                matterID: matterId,
                oldKey: matter?.identifier?.matterMapping?.fieldKey,
                newKey: mfChangeIdentifier.identifier,
            },
        });
        if (response.data) {
            setStatuses(response.data);
        } else {
            throw new Error("Wow ");
        }
        setExpanded(true);
        await refreshData();
    };

    useEffect(() => {
        refreshData();
    }, []);

    useEffect(() => {
        if (deleteing) {
            setDeleteModal(true);
        }
    }, [deleteing]);

    const editColumn = async () => {
        const response = await MatterService.editCol({
            body: {
                matterID: matterId ?? APIModels.EmptyGuid,
                //oldKey: noEditMergeField?.identifier,
                //oldName: noEditMergeField?.value,
                //newKey: mergeField?.identifier,
                //newName: mergeField?.value,
            },
        });
        if (response.data) {
            setStatuses(response.data);
        } else {
            throw new Error("Wow ");
        }
        await refreshData();
        setExpanded(true);
        closeMfRow();
    };
    const deleteColumn = async () => {
        const response = await MatterService.deleteCol({
            body: {
                matterID: matterId ?? APIModels.EmptyGuid,
                oldKey: noEditMergeField?.identifier,
                newKey: mergeField?.identifier,
                oldName: "",
                newName: "",
            },
        });
        if (response.data) {
            setStatuses(response.data);
        } else {
            throw new Error("Wow ");
        }
        await refreshData();
        setExpanded(true);
        setDeleteModal(false);
    };

    const editColumnRow = (k: WriteableMergeField) => {
        setMergeField(k);
        setNoEditMergeField(k);
    };

    const closeMfRow = () => {
        setMergeField(undefined);
        setNoEditMergeField(undefined);
    };

    useEffect(() => {
        if (mergeField === undefined) {
            setMfRowShow(false);
        }
        setMfRowShow(true);
    }, [mergeField]);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">
                                Edit Matter: <b>{matter?.matterNumber}</b>
                            </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="/dashboard"> eFileMadeEasy </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="/matter/management">
                                            {" "}
                                            Matter Management{" "}
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        {" "}
                                        Edit Matter{" "}
                                        <b>{matter?.matterNumber}</b>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <Dialog
                    open={deleteModal ?? false}
                    onClose={() => {
                        setDeleteModal(false);
                    }}
                    PaperProps={{
                        component: "form",
                        onSubmit: async (
                            event: React.FormEvent<HTMLFormElement>
                        ) => {
                            event.preventDefault();
                            const formData = new FormData(event.currentTarget);
                            const formJson = Object.fromEntries(
                                (formData as any).entries()
                            ) as { delete: string };
                            if (formJson.delete === "DELETE") {
                                await deleteColumn();
                                setDeleting(undefined);
                            } else {
                                console.warn(formJson.delete);
                            }
                            await refreshData();
                        },
                    }}
                >
                    <DialogTitle>
                        You are about to delete Column: {deleteing ?? ""}
                    </DialogTitle>
                    <DialogContent>
                        <Stack direction={"column"}>
                            <span>
                                <b>
                                    This cannot be undone. Any Matters with
                                    Mergefield Identifier: {deleteing} will also
                                    lose this column as well.
                                    <br /> <br />
                                    If you understand this, and understand that
                                    eFileMadeEasy and Legal Automation Systems
                                    Inc. are not responsible for any loss of
                                    data; type DELETE down below.
                                </b>
                            </span>
                            <Input
                                name="delete"
                                required
                                title="Type Delete to Continue"
                            />
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                        <Stack direction="row-reverse" spacing={4}>
                            <Button
                                color="error"
                                type="submit"
                                variant="contained"
                            >
                                Delete
                            </Button>
                            <Button
                                color="primary"
                                type="button"
                                variant="contained"
                                onClick={() => setDeleteModal(false)}
                            >
                                Cancel
                            </Button>
                        </Stack>
                    </DialogActions>
                </Dialog>
                <Stack direction="column" spacing={4}>
                    <Stack direction="column" spacing={2}>
                        <Card sx={{ width: "100%", paddingY: 1, paddingX: 2 }}>
                            <Stack direction="row" spacing={6}>
                                <Link
                                    to="/matter/management"
                                    type="button"
                                    className="btn btn-primary float-right mr-3"
                                >
                                    Matter Management
                                </Link>
                                <Link
                                    to="/matter/create"
                                    type="button"
                                    className="btn btn-primary float-right mr-3"
                                >
                                    Create New Matter
                                </Link>
                                <Link
                                    to="/matter/archived"
                                    type="button"
                                    className="btn btn-primary float-right mr-3"
                                >
                                    View Archived Items
                                </Link>
                                <Link
                                    to="/matter/import"
                                    type="button"
                                    className="btn btn-primary float-right mr-3"
                                >
                                    Import
                                </Link>
                            </Stack>
                        </Card>
                    </Stack>
                    <DatabaseCard
                        statuses={statuses}
                        expand={expanded}
                        setExpanded={setExpanded}
                        title={"View Edit Logs"}
                    />
                    <Card>
                        <div className="row">
                            <Table>
                                <TableHead>
                                    <TableCell width="3rem"> ID? </TableCell>
                                    <TableCell>Mergefield Key</TableCell>
                                    <TableCell>Mergefield Value</TableCell>
                                    <TableCell></TableCell>
                                </TableHead>
                                <TableBody>
                                    {mergeFields.map((k) => (
                                        <TableRow key={k.key}>
                                            {mfRowShow &&
                                            mergeField?.key === k.key ? (
                                                <>
                                                    <TableCell width="3rem">
                                                        {k.key ==
                                                            matterIdentifier && (
                                                            <span
                                                                style={{
                                                                    width: "100%",
                                                                }}
                                                            >
                                                                <Star />
                                                            </span>
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        <input
                                                            type="text"
                                                            value={
                                                                mergeField.identifier
                                                            }
                                                            placeholder="Mergefield Identifier"
                                                            onChange={(e) => {
                                                                setMergeField({
                                                                    ...mergeField,
                                                                    identifier:
                                                                        e
                                                                            .currentTarget
                                                                            .value,
                                                                });
                                                            }}
                                                            className="form-control"
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <input
                                                            type="text"
                                                            value={
                                                                mergeField.value
                                                            }
                                                            placeholder="Mergefield Value"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                setMergeField({
                                                                    ...mergeField,
                                                                    value: e
                                                                        .currentTarget
                                                                        .value,
                                                                });
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell width={"4rem"}>
                                                        <Stack
                                                            direction="row"
                                                            spacing={2}
                                                        >
                                                            <Button
                                                                color="success"
                                                                variant="contained"
                                                                onClick={async () =>
                                                                    await editColumn()
                                                                }
                                                            >
                                                                Save
                                                            </Button>
                                                            <Button
                                                                color="success"
                                                                variant="contained"
                                                                disabled={
                                                                    k.key ===
                                                                    matterIdentifier
                                                                }
                                                                onClick={async () =>
                                                                    await changeIdentifier(
                                                                        k
                                                                    )
                                                                }
                                                            >
                                                                Make ID
                                                            </Button>
                                                            <Button
                                                                color="error"
                                                                variant="contained"
                                                                onClick={() => {
                                                                    if (
                                                                        k.identifier ===
                                                                        matter
                                                                            ?.identifier
                                                                            ?.matterMapping
                                                                            ?.fieldKey
                                                                    ) {
                                                                        alert(
                                                                            "You Cannot Delete Your Matter Identifier, Please Change the Matter Identifier First."
                                                                        );
                                                                    } else {
                                                                        setDeleting(
                                                                            k.identifier
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                Delete
                                                            </Button>
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                onClick={
                                                                    closeMfRow
                                                                }
                                                            >
                                                                Cancel
                                                            </Button>
                                                        </Stack>
                                                    </TableCell>
                                                </>
                                            ) : (
                                                <React.Fragment>
                                                    <TableCell
                                                        width="3rem"
                                                        sx={{
                                                            justifyItems:
                                                                "center",
                                                        }}
                                                    >
                                                        {k.key ==
                                                            matterIdentifier && (
                                                            <span
                                                                style={{
                                                                    width: "100%",
                                                                }}
                                                            >
                                                                <Star />
                                                            </span>
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        <input
                                                            type="text"
                                                            value={k.identifier}
                                                            disabled
                                                            placeholder="Mergefield Identifier"
                                                            className="form-control"
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <input
                                                            type="text"
                                                            value={k.value}
                                                            disabled
                                                            placeholder="Mergefield Value"
                                                            className="form-control"
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            onClick={() =>
                                                                editColumnRow(k)
                                                            }
                                                        >
                                                            Edit
                                                        </Button>
                                                    </TableCell>
                                                </React.Fragment>
                                            )}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </Card>
                </Stack>
            </div>
        </div>
    );
};

export default EditPage;
